import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { TabsModule } from 'primeng/tabs';

type ActiveTab = 'sessions' | 'calls';

/**
 * Shell для /conversations. Держит только UI-таблист + <router-outlet>.
 * Дочерние роуты (SessionsList / CallsList) рендерятся в outlet — сам
 * shell не пересоздаётся при переключении, поэтому PrimeNG-tabs не
 * инициализируется заново (никакого FOUC «СессииЗвонки»).
 */
@Component({
  selector: 'app-conversations-shell',
  imports: [RouterOutlet, TabsModule],
  templateUrl: './conversations-shell.component.html',
  styleUrl: './conversations-shell.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConversationsShellComponent {
  private router = inject(Router);

  readonly activeTab = signal<ActiveTab>(this.tabFromUrl(this.router.url));

  constructor() {
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      takeUntilDestroyed(),
    ).subscribe(() => this.activeTab.set(this.tabFromUrl(this.router.url)));
  }

  onTabChange(value: ActiveTab): void {
    if (value === this.activeTab()) return;
    this.router.navigate(['/conversations', value], { queryParamsHandling: 'preserve' });
  }

  private tabFromUrl(url: string): ActiveTab {
    return url.split('?')[0].endsWith('/calls') ? 'calls' : 'sessions';
  }
}
